$('html').on('click', '.hp-produkt .btn.btn-to-cart', function(e){
	e.preventDefault
	//var findmumber = $(this).closest('.add-to-cart').find('input.amount').val()
	//console.log(findmumber)
	var findcode = $(this).attr('product-id')
	shoptet.cartShared.addToCart({productCode: ''+findcode+'', amount: 1});
})

